<template>
  <div class="c-baner">
    <img src="@/assets/baner2.jpg" alt="JLR Inchcape" class="c-baner__image" />
    <div class="c-baner__text">
      <a href="#select-brand" class="c-baner__btn">
        <h1>UMÓW SIĘ NA WIZYTĘ SERWISOWĄ ONLINE</h1>
      </a>
      <a href="#contact" class="c-baner__btn">
        <h1>SKONTAKTUJ SIĘ Z NAMI</h1>
      </a>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.c-baner {
  line-height: 0;
  position: relative;
  &__image {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    display: block;
  }
  &__text {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    h1 {
      line-height: 2rem;
      @media (max-width: 780px) {
        text-align: center;
      }
    }
  }
  &__btn {
    color: #fff;
    text-decoration: none;
    border: 3px solid #fff;
    padding: 1rem 2rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    h1 {
      font-size: 1.7rem;
      margin: 0;
      @media (max-width: 780px) {
        font-size: 1rem;
      }
    }
  }
}
</style>
